import { fromJS } from 'immutable';
import * as ACTIONS from  '../containers/constants';

const initialState = fromJS({});

export function linkedInfodexReducer(state = initialState, action) {

  switch (action.type) {
    case ACTIONS.CRYODEX_INFODEX_LINKED_UPDATE:
        return {
        ...state,
        data: action.payload,
        };
    default:
      return state;
  }
}

export default linkedInfodexReducer;
